import { Breadcrumbs, EcommerceExperience, OtherServices, WhyEcommerce } from "@/components/features/EcommerceSolution";
import Footer from "../../components/common/layout/Footer";
import SEO from "@/components/common/seo/seo";
import CallToAction from "@/components/common/sections/CallToAction";

export default function EcommerceSolution() {
    return(
        <div>
            {/* SEO for Home Page */}
            <SEO
                title="E-commerce Solutions - SAN micron"
                description="Empower Your Business Online Revolutionize your E-Commerce Experience Explore innovative solutions designed to enhance your online business presence and stimulate growth."
            />

           <Breadcrumbs />
           <WhyEcommerce />
           <EcommerceExperience />
           <CallToAction 
                title="Revolutionize your E-Commerce Experience"
            />
           <OtherServices />
            <div className="abstract-bg">
                 {/* <FAQ /> */}
            </div>
            <Footer />
        </div>
    );
}